import spriteSvg from '@/assets/images/sprite.svg';
import React, { useEffect, useState } from 'react';
import { storage } from '@/lib/storage';
import { Link } from 'react-router-dom';

export const ModalAgeVerification = () => {
  const [showModal, setShowModal] = useState<boolean>(false);

  useEffect(() => {
    setShowModal(!storage.ageVerified.isVerified());
  }, [showModal]);

  const onOkClick = () => {
    storage.ageVerified.setVerified();
    setShowModal(false);
  };

  const onNgClick = (e: React.MouseEvent) => {
    e.preventDefault();
    window.location.replace('https://www.cityheaven.net/');
  };

  if (showModal) {
    return (
      <div className="blur-modal-wrapper active">
        <div className="age-confirmation-modal">
          <svg className="icon">
            <use xlinkHref={`${spriteSvg}#icon-age`} />
          </svg>
          <h2 className="title">年齢認証</h2>
          <p>
            この先は成人向けのコンテンツを含んでいます。
            <br />
            そのため、18歳未満の方の閲覧は固くお断りしています。
          </p>
          <div className="label">18歳以上ですか？</div>
          <div className="control-group">
            <button className="btn-arrow" onClick={onOkClick}>
              はい、18歳以上です
              <svg className="i">
                <use xlinkHref={`${spriteSvg}#icon-arrow-right`} />
              </svg>
            </button>
            <div className="options">
              <Link to="" onClick={onNgClick}>
                いいえ
              </Link>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return <></>;
};
